<template>
  <div class="ti-dealer-confirmation">
    <div
      class="ti-dealer-confirmation__inner active"
      ref="containerParallax"
      :style="{
        'background-image': `url(${$parseSrc('/assets/confirmation/img_ti_confirmation_blur.jpg')})`,
      }"
    >
      <div
        class="ti-dealer-confirmation__stars-pattern"
        ref="starsPattern"
        :style="{
          'background-image': `url(${$parseSrc('/assets/confirmation/img_ti_star_pattern.svg')})`,
        }"
      ></div>

      <div
        class="ti-email-confirmation__text"
        v-if="valuation === '' || valuation === null"
      >
        <div class="ti-email-confirmation__icon" ref="iconOldCarWhite"></div>

        <h3>{{ $t('i18n.dealerConfirmation.error.headline') }}</h3>

        <p>{{ $t('i18n.dealerConfirmation.error.copy') }}</p>
      </div>

      <div
        class="ti-dealer-confirmation__text"
        v-if="!isOneJourney && valuation && valuation.length > 0"
      >
        <div class="ti-dealer-confirmation__icon" ref="iconContactWhite"></div>

        <h3>{{ $t('i18n.dealerConfirmation.contact.headline') }}</h3>

        <p>{{ $t('i18n.dealerConfirmation.contact.copy') }}</p>
      </div>

      <div
        class="ti-dealer-confirmation__text"
        v-if="isOneJourney && valuation && valuation.length > 0"
      >
        <div class="ti-dealer-confirmation__icon" ref="iconMoneyWhite"></div>

        <h3>{{ $t('i18n.dealerConfirmation.residualValue.headline') }}</h3>

        <p>{{ $t('i18n.dealerConfirmation.residualValue.copy') }}</p>

        <div
          class="ti-dealer-confirmation__price"
          :class="{
            'ti-dealer-confirmation__price--large': valuation?.length < 14,
          }"
        >
          <span>{{ valuation }}</span>
          <ModalComponent
            class="ti-dealer-confirmation__tooltip"
            :modal="$t('i18n.basicContactConfirmation.residualValue.modal')"
            :theme="ModalTheme.Dark"
          />
        </div>
      </div>

      <div class="ti-dealer-confirmation__dealer-info" v-if="dealer">
        <p>
          <wb-icon
            name="bds/mb-star/24"
            class="ti-dealer-confirmation__mercedes-icon"
          ></wb-icon>
          <strong>{{ dealer.baseInfo.name1 }}</strong>
          · {{ dealer.address.line1 }} · {{ dealer.address.zipcode }}
          {{ dealer.address.city }}
        </p>
      </div>

      <button
        v-if="originatingApp === 'medashboard'"
        @click="goToMeDashboard()"
        type="button"
        class="ti-dealer-confirmation__medashboard-button wb-button wb-button--theme-dark wb-button--secondary wb-button--medium"
      >
        <wb-icon
          class="wb-button__icon"
          aria-hidden="true"
          flip-rtl
          name="chevron-right"
        ></wb-icon>
        {{ $t('i18n.meDashboard.returnButton.copy') }}
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import setup from '../../composables/setup';
import { DealerInformation } from '@tradein/api';
import { ScrollService, MediaQueryService, MediaQuery } from 'workbench-core';
import lottie from 'lottie-web';
import ModalComponent from '../modal/modal.vue';
import { ModalTheme } from '../../utils/interfaces';
import { onMounted, ref } from 'vue';

interface Props {
  valuation?: String;
  dealer?: DealerInformation;
  isOneJourney: Boolean;
}

const props = defineProps<Props>();
const { applicationInfos, originatingApp, $parseSrc } = setup();

const containerParallax = ref<HTMLElement | null>(null);
const starsPattern = ref<HTMLElement | null>(null);

const scrollService = new ScrollService();
const myMediaQueryService = new MediaQueryService(window);
var lastScroll = window.scrollY;

const iconOldCarWhite = ref<Element | null>(null);
const iconContactWhite = ref<Element | null>(null);
const iconMoneyWhite = ref<Element | null>(null);

const parallaxFn = () => {
  if (containerParallax.value && starsPattern.value) {
    let element = containerParallax.value;
    let pattern = starsPattern.value;
    const currentMediaQuery: MediaQuery =
      myMediaQueryService.getCurrentMediaQuery();
    let position = element.getBoundingClientRect() as DOMRect;
    let starsPosition: number = parseFloat(
      window
        .getComputedStyle(pattern)
        .getPropertyValue('background-position-y'),
    );

    if (currentMediaQuery == 'mq6') {
      if (
        position.top + position.height >= 0 &&
        position.bottom - position.height <= window.innerHeight
      ) {
        if (lastScroll < window.scrollY) {
          pattern.style.backgroundPositionY = starsPosition - 1 + 'px';
        } else {
          pattern.style.backgroundPositionY = starsPosition + 1 + 'px';
        }
        lastScroll = window.scrollY;
      }
    }
  }
};

scrollService.register(parallaxFn);

const goToMeDashboard = () => {
  window.location.replace(applicationInfos.value.meDashboardUrl);
};

onMounted(() => {
  lottie.loadAnimation({
    container: iconOldCarWhite.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_oldcar_white.json`),
  });

  lottie.loadAnimation({
    container: iconContactWhite.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_contact_white.json`),
  });

  lottie.loadAnimation({
    container: iconMoneyWhite.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_money_white.json`),
  });
});
</script>

<style lang="scss" src="./dealer-confirmation.scss"></style>
